/* eslint-disable */
<template>
  <div class="container-fluid no-padding">
    <div class="row bg-primary-dark border-bottom">
      <div class="col-md-3 mb-2 mt-2">
        <input class="form-control btn-more-radius" @keyup.enter="getNotes()" v-model="queryModel.SearchFilter"
          type="text" placeholder="Notlarınızda arama yapın...">
      </div>
      <div class="col-md-3 mb-2 mt-2">
        <select class="custom-select btn-more-radius" v-model="queryModel.NoteType" @change="getNotes()">
          <option selected value="-1">Tüm Notlar</option>
          <option value="0">Çek Ödemeleri</option>
          <option value="1">İSKİ Ödemeleri</option>
          <option value="2">İGDAŞ Ödemeleri</option>
          <option value="3">AYEDAŞ Ödemeleri</option>
          <option value="4">Banka & Krediler</option>
          <option value="5">Kredi Kartları</option>
          <option value="6">Maaş Ödemeleri</option>
        </select>
      </div>
      <div class="col-md-3 mb-2 mt-3 align-middle">
        <div class="custom-control custom-checkbox align-middle">
          <input type="checkbox" class="custom-control-input" v-model="showOlds" id="checkAllUcks">
          <label class="custom-control-label" for="checkAllUcks">Tarihi Geçmişleri Göster</label>
        </div>
      </div>
      <div class="col-md-3 mb-2 mt-2">
        <button class="btn btn-more-radius btn-success float-right" data-toggle="modal"
          data-target="#modalCreateNote" v-if="canUseNotes">Yeni Not Oluştur</button>
      </div>
    </div>
    <div class="row" v-if="!showOlds">
      <v-wait for="notes-loading">
        <template slot="waiting">
          <div class="vue-wait-class">
            <img src="static/loading.svg" />
            <p>Notlar Yükleniyor...</p>
          </div>
        </template>
      </v-wait>
      <div class="col-md-3 border-right">
        <p class="text-center my-2 font-semi-bold">Bugün</p>
        <div class="card mb-3 text-white" v-for="(note, index) in notesToday" v-bind:key="'note-'+ index">
          <div class="card-body">
            <div class="dropdown card-menu">
              <button class="btn btn-sm btn-light" type="button" 
                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v text-dark"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="selectNote(index, note.NOTE_ID)"
                  data-toggle="modal" data-target="#modalCreateNote" aria-expanded="false">
                  <i class="far fa-edit mr-2"></i>Düzenle</a>
                <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 0)">
                  <i class="far fa-square mr-2"></i>Tamamla</a>
                <a v-else class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 1)">
                  <i class="fas fa-check-square mr-2"></i>Aktif et</a>
                <a class="dropdown-item text-danger" @click="deleteNote(index, note.NOTE_ID)">
                  <i class="fas fa-trash-alt text-danger mr-2"></i>Sil</a>
                <!-- @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 3, index)" -->
              </div>
            </div>
            <h5 class="card-title" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_CAPTION}}</h5>
            <p class="card-text" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_DESCRIPTION}}</p>
            <p class="card-text align-middle" v-if="note.NOTE_STATUS == 1">
              <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-primary mt-1"><i class="far fa-clock text-white"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
              <span v-else class="badge badge-primary mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
              <span class="badge mt-1" :class="parseNoteTypeAsClass(note.NOTE_TYPE)">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
              <span v-if="note.NOTE_PRICE > 0" class="badge badge-dark mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
            </p>
            <p class="card-text align-middle" v-else>
              <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-muted mt-1"><i class="far fa-clock"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
              <span v-else class="badge badge-muted mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
              <span class="badge mt-1 badge-muted">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
              <span v-if="note.NOTE_PRICE > 0" class="badge badge-muted mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3 border-right">
        <p class="text-center my-2 font-semi-bold">Yarın</p>
        <div class="card mb-3 text-white" v-for="(note, index) in notesTomorrow" v-bind:key="'note-'+ index">
          <div class="card-body">
            <div class="dropdown card-menu">
              <button class="btn btn-sm btn-light" type="button" 
                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v text-dark"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="selectNote(index, note.NOTE_ID)"
                  data-toggle="modal" data-target="#modalCreateNote" aria-expanded="false">
                  <i class="far fa-edit mr-2"></i>Düzenle</a>
                <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 0)">
                  <i class="far fa-square mr-2"></i>Tamamla</a>
                <a v-else class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 1)">
                  <i class="fas fa-check-square mr-2"></i>Aktif et</a>
                <a class="dropdown-item text-danger" @click="deleteNote(index, note.NOTE_ID)">
                  <i class="fas fa-trash-alt text-danger mr-2"></i>Sil</a>
                <!-- @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 3, index)" -->
              </div>
            </div>
            <h5 class="card-title" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_CAPTION}}</h5>
            <p class="card-text" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_DESCRIPTION}}</p>
            <p class="card-text align-middle" v-if="note.NOTE_STATUS == 1">
              <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-primary mt-1"><i class="far fa-clock text-white"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
              <span v-else class="badge badge-primary mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
              <span class="badge mt-1" :class="parseNoteTypeAsClass(note.NOTE_TYPE)">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
              <span v-if="note.NOTE_PRICE > 0" class="badge badge-dark mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
            </p>
            <p class="card-text align-middle" v-else>
              <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-muted mt-1"><i class="far fa-clock"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
              <span v-else class="badge badge-muted mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
              <span class="badge mt-1 badge-muted">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
              <span v-if="note.NOTE_PRICE > 0" class="badge badge-muted mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3 border-right">
        <p class="text-center my-2 font-semi-bold">Bu hafta içindekiler</p>
        <div class="card mb-3 text-white" v-for="(note, index) in notesInWeek" v-bind:key="'note-'+ index">
          <div class="card-body">
            <div class="dropdown card-menu">
              <button class="btn btn-sm btn-light" type="button" 
                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v text-dark"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="selectNote(index, note.NOTE_ID)"
                  data-toggle="modal" data-target="#modalCreateNote" aria-expanded="false">
                  <i class="far fa-edit mr-2"></i>Düzenle</a>
                <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 0)">
                  <i class="far fa-square mr-2"></i>Tamamla</a>
                <a v-else class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 1)">
                  <i class="fas fa-check-square mr-2"></i>Aktif et</a>
                <a class="dropdown-item text-danger" @click="deleteNote(index, note.NOTE_ID)">
                  <i class="fas fa-trash-alt text-danger mr-2"></i>Sil</a>
                <!-- @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 3, index)" -->
              </div>
            </div>
            <h5 class="card-title" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_CAPTION}}</h5>
            <p class="card-text" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_DESCRIPTION}}</p>
            <p class="card-text align-middle" v-if="note.NOTE_STATUS == 1">
              <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-primary mt-1"><i class="far fa-clock text-white"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
              <span v-else class="badge badge-primary mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
              <span class="badge mt-1" :class="parseNoteTypeAsClass(note.NOTE_TYPE)">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
              <span v-if="note.NOTE_PRICE > 0" class="badge badge-dark mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
            </p>
            <p class="card-text align-middle" v-else>
              <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-muted mt-1"><i class="far fa-clock"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
              <span v-else class="badge badge-muted mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
              <span class="badge mt-1 badge-muted">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
              <span v-if="note.NOTE_PRICE > 0" class="badge badge-muted mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <p class="text-center my-2 font-semi-bold">Yaklaşanlar</p>
        <div class="card mb-3 text-white" v-for="(note, index) in notesComing" v-bind:key="'note-'+ index">
          <div class="card-body">
            <div class="dropdown card-menu">
              <button class="btn btn-sm btn-light" type="button" 
                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v text-dark"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="selectNote(index, note.NOTE_ID)"
                  data-toggle="modal" data-target="#modalCreateNote" aria-expanded="false">
                  <i class="far fa-edit mr-2"></i>Düzenle</a>
                <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 0)">
                  <i class="far fa-square mr-2"></i>Tamamla</a>
                <a v-else class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 1)">
                  <i class="fas fa-check-square mr-2"></i>Aktif et</a>
                <a class="dropdown-item text-danger" @click="deleteNote(index, note.NOTE_ID)">
                  <i class="fas fa-trash-alt text-danger mr-2"></i>Sil</a>
                <!-- @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 3, index)" -->
              </div>
            </div>
            <h5 class="card-title" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_CAPTION}}</h5>
            <p class="card-text" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_DESCRIPTION}}</p>
            <p class="card-text align-middle" v-if="note.NOTE_STATUS == 1">
              <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-primary mt-1"><i class="far fa-clock text-white"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
              <span v-else class="badge badge-primary mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
              <span class="badge mt-1" :class="parseNoteTypeAsClass(note.NOTE_TYPE)">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
              <span v-if="note.NOTE_PRICE > 0" class="badge badge-dark mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
            </p>
            <p class="card-text align-middle" v-else>
              <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-muted mt-1"><i class="far fa-clock"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
              <span v-else class="badge badge-muted mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
              <span class="badge mt-1 badge-muted">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
              <span v-if="note.NOTE_PRICE > 0" class="badge badge-muted mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="card-columns m-3" v-if="showOlds">
      <v-wait for="notes-loading">
        <template slot="waiting">
          <div class="vue-wait-class">
            <img src="static/loading.svg" />
            <p>Notlar Yükleniyor...</p>
          </div>
        </template>
      </v-wait>
      <div class="card text-white" v-for="(note, index) in notesToShow" v-bind:key="'note-'+ index">
        <div class="card-body">
          <div class="dropdown card-menu">
            <button class="btn btn-sm btn-light" type="button" 
              id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-ellipsis-v text-dark"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="selectNote(index, note.NOTE_ID)"
                data-toggle="modal" data-target="#modalCreateNote" aria-expanded="false">
                <i class="far fa-edit mr-2"></i>Düzenle</a>
              <a v-if="note.NOTE_STATUS == 1" class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 0)">
                <i class="far fa-square mr-2"></i>Tamamla</a>
              <a v-else class="dropdown-item" @click="assignNoteStatus(index, note.NOTE_ID, 1)">
                <i class="fas fa-check-square mr-2"></i>Aktif et</a>
              <a class="dropdown-item text-danger" @click="deleteNote(index, note.NOTE_ID)">
                <i class="fas fa-trash-alt text-danger mr-2"></i>Sil</a>
               @click="assignStatusToAriza(ariza.ARIZA_ID, ariza.STATUS, 3, index)"
            </div>
          </div>
          <h5 class="card-title" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_CAPTION}}</h5>
          <p class="card-text" :class="{'text-muted' : note.NOTE_STATUS == 0}">{{note.NOTE_DESCRIPTION}}</p>
          <p class="card-text align-middle" v-if="note.NOTE_STATUS == 1">
            <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-primary mt-1"><i class="far fa-clock text-white"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
            <span v-else class="badge badge-primary mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
            <span class="badge mt-1" :class="parseNoteTypeAsClass(note.NOTE_TYPE)">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
            <span v-if="note.NOTE_PRICE > 0" class="badge badge-dark mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
          </p>
          <p class="card-text align-middle" v-else>
            <span v-if="note.NOTE_REMINDER_TYPE == 0" class="badge badge-muted mt-1"><i class="far fa-clock"></i>&nbsp;&nbsp;{{note.NOTE_DATE_FORMATTED}}</span>
            <span v-else class="badge badge-muted mt-1">{{parseReminderTypeAsView(note.NOTE_REMINDER_TYPE, note.NOTE_DAYNAME, note.NOTE_DAYINMONTH)}}</span>
            <span class="badge mt-1 badge-muted">{{parseNoteTypeAsView(note.NOTE_TYPE)}}</span>
            <span v-if="note.NOTE_PRICE > 0" class="badge badge-muted mt-1">{{parseNotePriceAsView(note.NOTE_PRICE, note.NOTE_CURRENCY)}}</span>
          </p>
        </div>
      </div>
    </div>
    <div v-if="canUseNotes" class="modal fade bd-example-modal-lg" id="modalCreateNote" tabindex="-1"
      role="dialog" aria-labelledby="exportUmeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Aşağıda bilgileri yer alan ürünü silmek istediğinizden emin misiniz ?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="note-saving">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Not Kaydediliyor...</p>
                </div>
              </template>
            </v-wait>
            <div class="container-fluid">
              <div class="form-row mb-2">
                <div class="form-group col-md-12">
                  <label for="note-caption">Not Başlığı</label>
                  <input type="text" v-model="selectedNote.NOTE_CAPTION" class="form-control" id="note-caption" placeholder="Not başlığı...">
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="form-group col-md-12">
                  <label for="note-desc">Not Açıklaması</label>
                  <textarea v-model="selectedNote.NOTE_DESCRIPTION" class="form-control" rows="3" id="note-desc" placeholder="Not açıklaması..."></textarea>
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="form-group col-md-12">
                  <label for="note-type">Not Türü</label>
                  <select v-model="selectedNote.NOTE_TYPE" class="custom-select" 
                    id="note-type" placeholder="Not açıklaması...">
                    <option selected value="-1">Tür seçiniz...</option>
                    <option value="0">Çek Ödemeleri</option>
                    <option value="1">İSKİ Ödemeleri</option>
                    <option value="2">İGDAŞ Ödemeleri</option>
                    <option value="3">AYEDAŞ Ödemeleri</option>
                    <option value="4">Banka & Krediler</option>
                    <option value="5">Kredi Kartları</option>
                    <option value="6">Maaş Ödemeleri</option>
                  </select>
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="form-group col-md-4">
                  <label for="note-price">Ödeme Miktarı</label>
                  <div class="input-group">
                    <input type="text" v-model="selectedNote.NOTE_PRICE" class="form-control" id="note-price" placeholder="Ödeme miktarı...">
                    <div class="input-group-append">
                      <button class="btn btn-primary dropdown-toggle" type="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{selectedCurrencyText}}&nbsp;</button>
                      <div class="dropdown-menu">
                        <a class="dropdown-item" @click="selectCurrency(0)">Türk Lirası</a>
                        <a class="dropdown-item" @click="selectCurrency(1)">Amerikan Doları</a>
                        <a class="dropdown-item" @click="selectCurrency(2)">Euro</a>
                        <a class="dropdown-item" @click="selectCurrency(3)">İngiliz Sterlini</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="note-date">Hatırlatma Tarihi</label>
                  <datepicker :bootstrap-styling="true" :use-utc="true" placeholder="Hatırlatma tarihi..." v-model="selectedNote.NOTE_DATE" :format="dateFormatter"></datepicker>
                </div>
                <div class="form-group col-md-4">
                  <label for="note-period">Hatırlatma Periyodu</label>
                  <select class="custom-select" id="note-period" v-model="selectedNote.NOTE_REMINDER_TYPE">
                    <option value="-1">Periyot seçiniz...</option>
                    <option value="0">Yalnızca bir defa</option>
                    <option value="1">Her hafta aynı günde</option>
                    <option value="2">Her ay aynı günde</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-success" @click="insertNote()">Notu Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import datepicker from 'vuejs-datepicker'
import axios from 'axios'
export default {
  name: 'NotesPage',
  components: {
    'datepicker': datepicker
  },
  data () {
    return {
      showOlds: false,
      notes: [],
      queryModel: {
        SessionId: '',
        NoteType: -1,
        SearchFilter: ''
      },
      selectedNote: {
        NOTE_TYPE: -1,
        NOTE_CURRENCY: 0,
        NOTE_REMINDER_TYPE: -1
      },
      backUpSelectedNote: {
        SessionId: '',
        NOTE_TYPE: -1,
        NOTE_CURRENCY: 0,
        NOTE_REMINDER_TYPE: -1
      },
      selectedCurrencyText: '₺',
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 3000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canUseNotes : function() { return this.$store.getters.userCanUseNotes; },
    notesToShow : {
      get: function() {
        if(this.showOlds)
          return this.notes.filter(m => (m.NOTE_DATEDIFF < 0 && m.NOTE_REMINDER_TYPE == 0) && m.NOTE_DELETED == 0)
        else
          return this.notes.filter(m => (m.NOTE_DATEDIFF >= 0 || (m.NOTE_DATEDIFF < 0 && m.NOTE_REMINDER_TYPE != 0)) && m.NOTE_DELETED == 0)
      }
    },
    notesToday: {
      get: function() {
        return this.notes.filter(m => (m.NOTE_DATEDIFF == 0 && m.NOTE_REMINDER_TYPE == 0 && m.NOTE_DELETED == 0));
      }
    },
    notesTomorrow: {
      get: function() {
        return this.notes.filter(m => (m.NOTE_DATEDIFF == 1 && m.NOTE_REMINDER_TYPE == 0 && m.NOTE_DELETED == 0));
      }
    },
    notesInWeek: {
      get: function() {
        return this.notes.filter(m => (m.NOTE_DATEDIFF > 1 && m.NOTE_DATEDIFF <= 7 && m.NOTE_REMINDER_TYPE == 0 && m.NOTE_DELETED == 0));
      }
    },
    notesComing: {
      get: function() {
        return this.notes.filter(m => (m.NOTE_DATEDIFF > 7 && m.NOTE_DELETED == 0));
      }
    }
  },
  methods: {
    getNotes() {
      this.$wait.start('notes-loading')

      this.queryModel.SessionId = this.getSessionId
      axios.post('/api/session/notes', this.queryModel)
      .then(response => {
        console.log(response.data)
        this.notes = response.data
        this.$wait.end('notes-loading')
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('notes-loading')
      })
    },
    insertNote() {
      if(this.selectedNote.NOTE_TYPE == -1) {
        this.$toasted.error('Not türünü seçmediniz', this.toastOptions)
        return
      }

      if(this.selectedNote.NOTE_REMINDER_TYPE == -1) {
        this.$toasted.error('Hatırlatma periyodunuz seçmediniz', this.toastOptions)
        return
      }

      if(this.selectedNote.NOTE_CAPTION == null || this.selectedNote.NOTE_CAPTION.length == 0) {
        this.$toasted.error('Not başlığını girmediniz', this.toastOptions)
        return
      }

      if(this.selectedNote.NOTE_DATE == null || this.selectedNote.NOTE_DATE.length == 0) {
        this.$toasted.error('Tarih seçmediniz', this.toastOptions)
        return
      }

      this.$wait.start('note-saving')
      this.selectedNote.SessionId = this.getSessionId
      axios.post('/api/session/note-create', this.selectedNote)
      .then(resp => {
        this.$toasted.success('Not kaydedildi', this.toastOptions)
        this.getNotes()
      })
      .catch(err => this.$toasted.error('Not kaydedilemedi. Durum: ' + err.data.ErrorMessage, this.toastOptions))

      $("#modalCreateNote").modal('hide')
      this.$wait.end('note-saving')
      this.selectedNote = this.backUpSelectedNote
    },
    async deleteNote(noteIndex, noteId) {
      await axios.post('/api/session/note-delete',
      { 'SessionId': this.getSessionId, 'NOTE_ID': noteId, 'NOTE_STATUS': 0 })
      .then(resp => {
        this.$toasted.success('Not silindi', this.toastOptions)
      })
      .catch(err => this.$toasted.error('Not güncellenemedi. Durum: ' + err.ErrorMessage, this.toastOptions))

      this.getNotes()
    },
    async assignNoteStatus(noteIndex, noteId, status) {
      await axios.post('/api/session/note-status',
      { 'SessionId': this.getSessionId, 'NOTE_ID': noteId, 'NOTE_STATUS': status })
      .then(resp => {
        let msg2 = status == 0 ? 'tamamlandı' : 'aktif edildi'
        msg2 = 'Not ' + msg2
        this.$toasted.success(msg2, this.toastOptions)
      })
      .catch(err => this.$toasted.error('Not güncellenemedi. Durum: ' + err.data.ErrorMessage, this.toastOptions))

      this.getNotes()
    },
    parseNoteTypeAsClass(noteType) {
      if(noteType == 0)
        return "badge-danger"
      if(noteType == 1 || noteType == 2 || noteType == 3)
        return "badge-secondary"
      if(noteType == 4)
        return "badge-info"
      if(noteType == 5)
        return "badge-warning"
      if(noteType == 6)
        return "badge-light"
    },
    parseNoteTypeAsView(noteType) {
      if(noteType == 0)
        return "ÇEK ÖDEMESİ"
      if(noteType == 1)
        return "İSKİ"
      if(noteType == 2)
        return "İGDAŞ"
      if(noteType == 3)
        return "AYEDAŞ"
      if(noteType == 4)
        return "BANKALAR"
      if(noteType == 5)
        return "KREDİ KARTLARI"
      if(noteType == 6)
        return "MAAŞ ÖDEMELERİ"
    },
    parseNotePriceAsView(notePrice, noteCurrency) {
      let curr = null;
      if(noteCurrency == 0)
        curr = "₺"
      if(noteCurrency == 1)
        curr = "$"
      if(noteCurrency == 2)
        curr = "€"
      if(noteCurrency == 3)
        curr = "£"
      
      return curr + ' ' + notePrice
    },
    parseNoteCurrencyAsView(noteCurrency) {
      if(noteCurrency == 0)
        return "₺"
      if(noteCurrency == 1)
        return "$"
      if(noteCurrency == 2)
        return "€"
      if(noteCurrency == 3)
        return "£"
    },
    parseReminderTypeAsView(noteReminder, noteDay, noteDayOfMonth) {
      if(noteReminder == 0)
        return "YALNIZCA BİR DEFA"
      if(noteReminder == 1)
        return "HER " + noteDay
      if(noteReminder == 2)
        return "HER AYIN " + noteDayOfMonth + ". GÜNÜ"
    },
    selectNote(noteIndex, noteId) {
      this.selectedNote = this.notes.find(m => m.NOTE_ID === noteId)
    },
    selectCurrency(noteCurrency) {
      this.selectedNote.NOTE_CURRENCY = noteCurrency
      this.selectedCurrencyText = this.parseNoteCurrencyAsView(noteCurrency)
    },
    dateFormatter(date) {
      return moment(date).format('DD.MM.YYYY')
    },
  },
  mounted() {
    moment.locale('tr')
    this.getNotes()
  }
}
</script>

<style scoped>

  @media (min-width: 1024px) {
    .card-columns {
      column-count: 4;
    }
  }

  @media (min-width: 1441px) {
    .card-columns {
      column-count: 5;
    }
  }

  .inner-notes {
    background-color: #010929;
    display: inline-block !important;
    height: calc(100vh - 300);
    max-height: 100% !important;
    overflow-y: scroll;
  }

  .font-semi-bold {
    font-weight: 500;
  }

  .card-menu {
    position: absolute;
    z-index: 2;
    top: 10px;
    right: 10px;
  }

  .badge {
    padding: 8px 15px;
    font-size: .875rem !important;
  }

  .badge-muted {
    color: #606060 !important;
    background-color: #E0E0E0;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: .75rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/NotesPage.vue